export const NotificationViewGrid = {
	size: 100,
	gap: 0,
	name: 'NotificationViewGrid',
	padding: {
		top: 5,
		bottom: 0,
		left: 5,
		right: 5,
		portrate: {
			top: 3,
			bottom: 3,
			left: 3,
			right: 3
		}
	},
	main: [
		{
			name: 'leftgrid',
			size: 70,
			type: 'PortrateGridController',
			config: {
				name: 'leftgrid',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 5
					},
					{
						name: 'notif_bg',
						height: 45,
						size: 70,
						bounds: {
							width: 634,
							height: 372
						}
					},
					{
						name: 'empty',
						size: 10
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'leftgrid',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'leftgrid',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 7
					},
					{
						name: 'notif_bg',
						height: 50,
						size: 70,
						bounds: {
							width: 634,
							height: 372
						}
					},
					{
						name: 'empty',
						size: 10
					}
				]
			}
		}
	],

	portrate: [
		{
			name: 'empty',
			size: 30
		},
		{
			name: 'notif_bg',
			size: 25,
			bounds: {
				width: 634,
				height: 372
			},
			align: 'center'
		}
	]
};
